import React, { Component } from 'react';
import { Calendar } from 'react-date-range';
import { Dropdown , Button, Grid } from 'semantic-ui-react';
import {tumRaporlar} from '../customerManagementTable/options'
import { SAPTumRaporlar } from '../customerManagementTable/options';
import agent from '../../../axios/agent';
import axios from 'axios';
import {makeLinkDate} from '../helpers';
import FileDownload from 'js-file-download';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import { PDFDocument } from 'pdf-lib'
import * as XLSX from "xlsx-js-style";

class SAPCustomerReport extends Component{
    constructor(props){
        super(props)
        this.state={
            customerReports: [],
            dropdownValue: null,
            dateStart: null,
            dateEnd: null,
            date: null,
            sapFirm: null,
            sapFirmNo: null,
            //sapProductType: null,
            file: null,
            wait: null,
            excelUrl: null,
            excellWait: null,
            permission: null,
            noValue: null,
            valuefileType: null,
            proccessingText:null,
        }
        this.dateConf = this.dateConf.bind(this)
        this.onClickSend = this.onClickSend.bind(this)
        this.downloadExcellFile = this.downloadExcellFile.bind(this)
        this.getFileFromCustomerPDFS = this.getFileFromCustomerPDFS.bind(this)
        this.downloadPdfFile = this.downloadPdfFile.bind(this)
    }

    componentDidMount(){
        let customerName = localStorage.getItem("Username");
        agent.Customers.list().then(response => {
          response.data.find(item => {
           if(item.sapReportType === null) 
            {
                return this.setState({
                        noValue: true
                })
                
            } 
           
            return(item.customerName === customerName ? 
                    this.setState({
                        customerReports: item.sapReportType.split(','),
                        sapFirm: item.sapFirm,
                        sapFirmNo: item.sapFirmNo,
                        //sapProductType: item.sapProductType

                      })
              :null)
              
          })
        })
    }


    dateConf(date) {
        //console.log(date)
        //console.log(date.getFullYear())
        let day = ("0" + (date.getDate())).slice(-2)
        let month = ("0" + (date.getMonth() + 1)).slice(-2)
        let year = date.getFullYear()
        return (year + "-" + month + "-" + day)
    }
    onClickSend(e){
        e.preventDefault();
        const {sapFirmNo, sapFirm, startDate, endDate, sapProductType, value, date, valuefileType} = this.state
        let dateTwice = date === "true" ? (this.dateConf(endDate)) : ""
        this.setState({
            proccessingText: "Please wait, datas sended / Lütfen Bekleyiniz, Veriler işleniyor."
        })
              let  formData = {
                customerName: localStorage.getItem("Username"),
                report_Number: value,
                company: "1000",
                fileType: valuefileType,
                dateStart:this.dateConf(startDate),
                dateEnd:dateTwice,
                customerCompany: sapFirmNo,
                //productType: sapProductType,
                //sapFirmNo:item.sapFirmNo
                //parameters: `Tarih:${this.dateConf(startDate)}${dateOnceOrTwice};stokG1:${productType};stokG2:${firmNo}`,
            }
        
        agent.SAPReportClaim.create(formData).then(response => {response.data.base64 ? 
            this.setState({
                dataFileName: response.data.base64,
                proccessingText: "Please wait, datas succesfully sended/ Lütfen bekleyiniz, Veriler başarıyla gönderildi"}) : 
            this.setState({proccessingText: "Something went wrong on API/ Bir hata oluştu, API "})})
    }

    getFileFromCustomerPDFS(dataFileName){
        this.state.valuefileType === 'E' ?
        this.downloadExcellFile(`${dataFileName}`) : 
        this.downloadPdfFile(`${dataFileName}`)
    }
 
    downloadExcellFile(fileUrl){
       // var url ="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+fileUrl;
       //window.open(url);
       /*
        var url="data:application/vnd.ms-excel;base64,"+fileUrl;
        const downloadLink = document.createElement("a");
        const fileName = "MefarRapor.xls";
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
       */
        
    // Base64'ü decode et (UTF-8 çözümü için TextDecoder kullanacağız)
    
          const binaryString = atob(fileUrl); // Base64 verisini binary'ye çevir
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
            
          // Binary veriyi Uint8Array'e çevir
          for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i);
          }
      
          // Binary veriyi doğru çözmek için TextDecoder kullanıyoruz
          const decoder = new TextDecoder("ISO-8859-9");  // ISO-8859-9 olarak çöz
          const decodedText = decoder.decode(bytes); // Veriyi string olarak çöz
      
          //console.log("Decoded Text: ", decodedText);
      
          const rows = decodedText.split('\n').map(row => row.split('\t'));
      
          //console.log("Rows Text: ", rows);
      
          // Excel dosyasını oluşturmak için AOA (Array of Arrays) kullanıyoruz
          const worksheet = XLSX.utils.aoa_to_sheet(rows);
      
      
          // Stil ekleme işlemi
          const range = XLSX.utils.decode_range(worksheet['!ref']); // Tüm hücre aralığını al
      
          for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
              const firstCell = XLSX.utils.encode_cell({ r: rowNum, c: 0 }); // İlk hücreyi al
              //console.log("Decoded Text: ", firstCell);
              if (!worksheet[firstCell] || worksheet[firstCell].v.trim() === "") { // İlk hücre boşsa
                 // console.log("Decoded Text2: ", firstCell);
                  for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
                      const cellRef = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                      if (worksheet[cellRef] && !worksheet[cellRef].v=="") {
                          if (!worksheet[cellRef].s) worksheet[cellRef].s = {}; // Stil nesnesi yoksa oluştur
                         // console.log(worksheet[cellRef]);
                          worksheet[cellRef].s = {font:{ bold:true },border:{bottom:true}}; // Hücreleri bold yap
                          //console.log(worksheet[cellRef]);
                      }
                  }
              }
          }
      
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          // Excel dosyasını Blob olarak oluştur
          let excelBlob = new Blob([XLSX.write(workbook, { bookType: "xlsx", type: "array", cellStyles: true })], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
          });
      
          // Dosyayı indir
          let link = document.createElement("a");
          link.href = URL.createObjectURL(excelBlob);
          link.download = "MefarRapor.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    }

    async downloadPdfFile(fileUrl){
       /*
        var url ="data:application/pdf;base64,"+fileUrl;
        const downloadLink = document.createElement("a");
        const fileName = "MefarRapor.pdf";
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();*/

        // Decode the Base64 string
         const pdfBuffer = Uint8Array.from(atob(fileUrl), c => c.charCodeAt(0));

         // Load a PDFDocument from the existing PDF bytes
         const pdfDoc = await PDFDocument.load(pdfBuffer);

         // Serialize the PDFDocument to bytes (a Uint8Array)
         const pdfBytes = await pdfDoc.save();

         // For this example, let's write it to a new file. In real-world scenarios, you'd probably 
         // want to send it to a server, display it in a viewer, etc.
         const blob = new Blob([pdfBytes], { type: 'application/pdf' });
         const link = document.createElement('a');
         link.href = URL.createObjectURL(blob);
         link.download = 'MefarRapor.pdf';
         link.click();

        }
    
    render(){
    const { value , date, noValue } = this.state
    let musteriRaporlar = this.state.customerReports;

    const today = new Date();
    // Bugünün tarihini "yyyy-mm-dd" formatına çeviriyoruz
    const disabledDates = [today]; // Sadece bugünü engellemek için

    let x = SAPTumRaporlar.filter((item) => {
        if(musteriRaporlar.includes(item.key)) 
        return item 
    })

    if(this.state.dataFileName)
        this.getFileFromCustomerPDFS(this.state.dataFileName)
        
    return(
            <Grid columns={1}>
                
                   
                    <Grid.Row >
                        <Grid.Column>
                            {this.state.proccessingText ? this.state.proccessingText :
                            <>
                                <Dropdown
                                    placeholder='Lütfen Rapor Seçiniz / Please, Choose your report type'
                                    fluid
                                    selection
                                    style={{marginTop:'15px'}}
                                    value={value}
                                    onChange={(e, { value }) => {
                                        SAPTumRaporlar.find(item => {
                                            this.setState({
                                                date: item.date,
                                                value: value}) 
                                            return (value === item.key)} )
                                    }}
                                    options={x}/>
                                <Dropdown
                                    placeholder='Lütfen, Dosya Tipini Seçiniz / Please, Choose file type for download'
                                    fluid
                                    selection
                                    value={this.state.valuefileType}
                                    onChange={(e, { value }) => {this.setState({valuefileType: value})}} 
                                    options={[{'key' : 'xls', 'text': 'Excel', 'value': 'E'},{'key' : 'pdf', 'text': 'Pdf', 'value': 'P'}]}
                                    style={{marginTop:'15px'}}/>
                                {
                                    date === "true" ? 
                                    <>
                                        <Calendar
                                            onChange={item => this.setState({startDate: item})}
                                            date={this.state.startDate}
                                            style={{minWidth: '86vh', fontSize: "16px"}}
                                            
                                        />
                                        <Calendar  
                                            onChange={item => this.setState({endDate: item})}
                                            date={this.state.endDate}
                                            style={{minWidth: '86vh', fontSize: "16px"}}
                                        />
                                <Button 
                                    disabled={(this.state.startDate == null) || (this.state.endDate == null)  || (this.state.valuefileType == null) || (this.state.value == null)} 
                                    className={'blockButton'} primary onClick={(e) => {this.onClickSend(e)}}>
                                            {this.state.startDate == null ? "Lütfen tarih seçiniz": "Dökümanı Göster"}
                                </Button>
                                    </>:
                                    <>
                                       <Calendar
                                        onChange={item => this.setState({startDate: item})}
                                        date={this.state.startDate}
                                        style={{minWidth: '178vh', fontSize: "16px"}}
                                        minDate={today}  // Sadece bugünden itibaren tarih seçilebilir
                                        maxDate={today}  // Sadece bugünün tarihi seçilebilir
                                        //disabledDates={disabledDates} // Bugünün dışındaki tüm tarihleri engelle
                                    />
                                <Button 
                                    disabled={(this.state.startDate == null) ||(this.state.valuefileType == null) || (this.state.value == null) } 
                                    className={'blockButton'} primary onClick={(e) => {this.onClickSend(e)}}>
                                           {this.state.startDate == null ? "Lütfen tarih seçiniz": "Dökümanı Göster"}
                                </Button>
                                </>
                                }
                               
                            </>
                        }
                        </Grid.Column>
                </Grid.Row>
                
                </Grid>
        )
    }
}

export {SAPCustomerReport}